module.exports = __webpack_public_path__ + "media/marketplace_fund/deck-preview-2-thumb-9801fa95.png";